<template>
  <div id="reserva">
    <vue-headful :title="$store.state.option['car_title-' + lang]" :lang="lang" />

    <button v-if="($store.state.user || logindriver === 2) && passo == 1" :disabled="!(($store.state.option['reserved-confirmacao1-' + lang] && form1.confirmacao1 || !$store.state.option['reserved-confirmacao1-' + lang]) && ($store.state.option['reserved-confirmacao2-' + lang] && form1.confirmacao2 || !$store.state.option['reserved-confirmacao2-' + lang]) && ($store.state.option['reserved-confirmacao3-' + lang] && form1.confirmacao3 || !$store.state.option['reserved-confirmacao3-' + lang]))" @click="avancarFN1()" class="btn btn-primary text-uppercase btn-block btn-vertical d-sm-block d-md-none">{{$store.state.option['reserved-confirmar-reserva-' + lang]}}<i class="fas fa-arrow-circle-right"></i></button>
    <button v-else-if="passo === 1" :disabled="!($store.state.option['reserved-confirmacao1-' + lang] && form1.confirmacao1 && (!$store.state.option['reserved-confirmacao2-' + lang] || $store.state.option['reserved-confirmacao2-' + lang] && form1.confirmacao2) && (!$store.state.option['reserved-confirmacao3-' + lang] || $store.state.option['reserved-confirmacao3-' + lang] && form1.confirmacao3))" class="btn btn-primary text-uppercase btn-block btn-vertical d-sm-block d-md-none" @click="logar()">{{$store.state.option['reserved-entrar-criar-conta-' + lang]}} <i class="fas fa-arrow-circle-right"></i></button>

    <modal name="login-modal" height="auto" maxwidth="600">
      <div class="row">
        <div class="col-md-6 col-lg-6 col-xs-12 col-sm-6" style="background:#e1e1e1;">
          <div class="col-lg-12 m-b-20">
            <h2 class="text-center" style="margin-top:15px;">{{$store.state.option['login_reserved-' + lang]}}</h2>
            <div class="card card-login mx-auto" style="margin: 0px;">
              <div class="card-body p-0">
                <form @submit.prevent="submitDriver()" style="background:#e1e1e1;">
                  <div class="form-group">
                    <div class="form-label-group">
                      <input type="email" id="inputEmail" class="form-control" :placeholder="$store.state.option['email2333-' + lang]" required="required" v-model="form2.email" />
                      <label for="inputEmail">{{$store.state.option['email2333-' + lang]}}</label>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label-group">
                      <input type="password" id="inputPassword" class="form-control" :placeholder="$store.state.option['senha-' + lang]" required="required" v-model="form2.password" @keydown.enter.prevent="submitDriver" />
                      <label for="inputPassword">{{$store.state.option['senha-' + lang]}}</label>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <a class="btn btn-primary btn-block btn-lg mao text-uppercase" style="margin-top:10px;" @click="submitDriver()" href="javascript:void(0)">{{$store.state.option['loginEntrar1-' + lang]}}</a>
                  <div class="clearfix"></div>
                  <!--<button class="d-block small mt-3 btn btn-default btn-block" @click="$modal.hide('login-modal');$modal.show('registar-modal');">{{$store.state.option['loginRegistar-' + lang]}}</button>-->
                </form>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-xs-12 col-sm-6">
          <div class="col-lg-12 m-b-20">
            <h2 class="text-center" style="margin-top:15px;">{{$store.state.option['registar_reserved1-' + lang]}}</h2>
            <div style="height:135px;"></div>

            <!--<button class="btn btn-primary btn-block btn-lg mao text-uppercase" style="margin-top:10px;" @click="$modal.hide('login-modal');$modal.show('registar-modal');">{{$store.state.option['loginRegistar1-' + lang]}}</button>-->
            <button class="btn btn-primary btn-block btn-lg mao text-uppercase" style="margin-top:10px;" @click="$modal.hide('login-modal');$modal.show('guest-modal');">{{$store.state.option['loginRegistar1-' + lang]}}</button>
          </div>
        </div>
      </div>
    </modal>
    <modal name="guest-modal" height="auto" maxwidth="600">
      <div class="row">
          <div class="col-lg-12 m-b-20">
            <h2 class="text-center" style="margin-top:15px;">{{$store.state.option['reserved_titleguest-' + lang]}}</h2>
            <div class="card card-login mx-auto" style="margin: 0px;">
              <div class="card-body p-0">
                  <div class="form-group">
                    <div class="form-label-group">
                      <input type="text" id="condutor112" class="form-control" :placeholder="$store.state.option['reserved-nome-condutor-' + lang]" v-model="condutor" />
                       <label for="condutor112">{{$store.state.option['reserved-nome-condutor-' + lang]}}</label>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label-group">
                      <input type="text" id="email1112" class="form-control" :placeholder="$store.state.option['email2333-' + lang]" v-model="email" />
                      <label for="email1112">{{$store.state.option['email2333-' + lang]}}</label>
                    </div>
                  </div>

                  <div class="form-group" style="margin-top:16px;" v-if="$store.state.option.address_register1 > 0">
                    <div class="form-row">
                      <div class="col-md-12">
                        <div class="form-label-group">
                          <textarea id="address" v-model="registar.address" class="form-control" :placeholder="$store.state.option['address-' + lang]"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" style="margin-top:16px;" v-if="$store.state.option.postal_Code_register1 > 0 || $store.state.option.city_register1 > 0">
                    <div class="form-row">
                      <div class="col-md-6" v-if="$store.state.option.postal_Code_register1 > 0">
                        <div class="form-label-group">
                          <input type="text" id="postal_Code" class="form-control" :placeholder="$store.state.option['postal_Code-' + lang]" required="required" v-model="registar.postal_Code" />
                          <label for="postal_Code">{{$store.state.option['postal_Code-' + lang]}}</label>
                        </div>
                      </div>
                      <div class="col-md-6" v-if="$store.state.option.city_register1 > 0">
                        <div class="form-label-group">
                          <input type="text" id="city" class="form-control" :placeholder="$store.state.option['city-' + lang]" required="required" v-model="registar.city" />
                          <label for="city">{{$store.state.option['city-' + lang]}}</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" v-if="$store.state.option.country1 > 0">
                    <div class="form-row">
                      <div class="col-md-12">
                        <div class="form-label-group">
                          <select id="country" class="form-control" required="required" v-model="registar.country" style="height:50px;">
                            <option value="" selected hidden>{{$store.state.option['country-' + lang]}}*</option>
                            <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" v-if="$store.state.option.license_Number_register1 > 0 || $store.state.option.taxNumber1 > 0">
                    <div class="form-row">
                      <div class="col-md-6" v-if="$store.state.option.license_Number_register1 > 0">
                        <div class="form-label-group">
                          <input type="text" id="license_Number" class="form-control" :placeholder="$store.state.option['license_Number-' + lang]" required="required" v-model="registar.license_Number" />
                          <label for="license_Number">{{$store.state.option['license_Number-' + lang]}}</label>
                        </div>
                      </div>
                      <div class="col-md-6" v-if="$store.state.option.taxNumber1 > 0">
                        <div class="form-label-group">
                          <input type="text" id="tax_number" class="form-control" :placeholder="$store.state.option['tax_number-' + lang]" required="required" v-model="registar.tax_number" />
                          <label for="tax_number">{{$store.state.option['tax_number-' + lang]}}</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" v-if="$store.state.option.idNumber1 > 0 || $store.state.option.passportNumber1 > 0">
                    <div class="form-row">
                      <div class="col-md-6" v-if="$store.state.option.idNumber1 > 0 && $store.state.option.passportNumber1 > 0">
                        <div class="form-label-group">
                          <select id="documentType" class="form-control" required="required" v-model="registar.document_Type" style="height:50px;">
                            <option value="" hidden>{{$store.state.option['documentType-' + lang]}}</option>
                            <option value="2">{{$store.state.option['documentTypePAssport-' + lang]}}</option>
                            <option value="1">{{$store.state.option['documentTypeID-' + lang]}}</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-6" v-if="$store.state.option.idNumber1 > 0 && registar.document_Type == 1">
                        <div class="form-label-group">
                          <input type="text" id="idNumber" class="form-control" :placeholder="$store.state.option['idNumber-' + lang]" required="required" v-model="registar.idNumber" />
                          <label for="idNumber">{{$store.state.option['idNumber-' + lang]}}</label>
                        </div>
                      </div>
                      <div class="col-md-6" v-if="$store.state.option.passportNumber1 > 0 && registar.document_Type == 2">
                        <div class="form-label-group">
                          <input type="text" id="passportNumber" class="form-control" :placeholder="$store.state.option['passportNumber-' + lang]" required="required" v-model="registar.passportNumber" />
                          <label for="passportNumber">{{$store.state.option['passportNumber-' + lang]}}</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" v-if="$store.state.option.phone_Number_register1 > 0 || $store.state.option.mobile_Number_register1 > 0">
                    <div class="form-row">
                      <div class="col-md-6" v-if="$store.state.option.phone_Number_register1 > 0">
                        <div class="form-label-group">
                          <input type="number" id="phone_Number" class="form-control" :placeholder="$store.state.option['phone_Number-' + lang]" required="required" v-model="registar.phone_Number" />
                          <label for="phone_Number">{{$store.state.option['phone_Number-' + lang]}}</label>
                        </div>
                      </div>
                      <div class="col-md-6" v-if="$store.state.option.mobile_Number_register1 > 0">
                        <div class="form-label-group">
                          <input type="number" id="mobile_Number" class="form-control" :placeholder="$store.state.option['mobile_Number-' + lang]" required="required" v-model="registar.mobile_Number" />
                          <label for="mobile_Number">{{$store.state.option['mobile_Number-' + lang]}}</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="clearfix"></div>
                  <a class="btn btn-primary btn-block btn-lg mao text-uppercase" style="margin-top:10px;" @click="guestFN()" href="javascript:void(0)">{{$store.state.option['reserved_buttonguest-' + lang]}}</a>
                  <div class="clearfix"></div>
              </div>
            </div>
          </div>
      </div>
    </modal>
    <modal name="registar-modal" height="auto" maxwidth="600">
      <div class="col-md-12 col-xs-12" style="margin-bottom: 15px;">
        <h2 class="text-center" style="margin-top:15px;">{{$store.state.option['registar_reserved-' + lang]}}</h2>
        <div class="form-group">
            <div class="form-group m-0">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="text" id="firstName" class="form-control" :placeholder="$store.state.option['driver_Name-' + lang]" required="required" autofocus="autofocus" v-model="registar.driver_Name" />
                    <label for="firstName">{{$store.state.option['driver_Name-' + lang]}}</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group"><input type="text" id="date_of_Birth" class="form-control" :placeholder="$store.state.option['date_of_Birth-' + lang]" required="required" autofocus="autofocus" v-model="aniversario" readonly v-mask="date_mask_local" />
                    <label for="date_of_Birth">{{$store.state.option['date_of_Birth-' + lang]}}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" style="margin-top:16px;" v-if="$store.state.option.address_register > 0">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-label-group">
                    <textarea id="address" v-model="registar.address" class="form-control" :placeholder="$store.state.option['address-' + lang]"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" style="margin-top:16px;" v-if="$store.state.option.postal_Code_register > 0 || $store.state.option.city_register > 0">
              <div class="form-row">
                <div class="col-md-6" v-if="$store.state.option.postal_Code_register > 0">
                  <div class="form-label-group">
                    <input type="text" id="postal_Code" class="form-control" :placeholder="$store.state.option['postal_Code-' + lang]" required="required" v-model="registar.postal_Code" />
                    <label for="postal_Code">{{$store.state.option['postal_Code-' + lang]}}</label>
                  </div>
                </div>
                <div class="col-md-6" v-if="$store.state.option.city_register > 0">
                  <div class="form-label-group">
                    <input type="text" id="city" class="form-control" :placeholder="$store.state.option['city-' + lang]" required="required" v-model="registar.city" />
                    <label for="city">{{$store.state.option['city-' + lang]}}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" style="margin-top:16px;">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-label-group">
                    <select id="country" class="form-control" required="required" v-model="registar.country" style="height:50px;">
                      <option value="" selected hidden>{{$store.state.option['country-' + lang]}}*</option>
                      <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="$store.state.option.license_Number_register > 0 || $store.state.option.license_Country_register > 0">
              <div class="form-row">
                <div class="col-md-6" v-if="$store.state.option.license_Number_register > 0">
                  <div class="form-label-group">
                    <input type="text" id="license_Number" class="form-control" :placeholder="$store.state.option['license_Number-' + lang]" required="required" v-model="registar.license_Number" />
                    <label for="license_Number">{{$store.state.option['license_Number-' + lang]}}</label>
                  </div>
                </div>
                <div class="col-md-6" v-if="$store.state.option.license_Country_register > 0">
                  <div class="form-label-group">
                    <select id="license_Country" class="form-control" required="required" v-model="registar.license_Country" style="height:50px;">
                      <option value="" selected hidden>{{$store.state.option['license_Country-' + lang]}}*</option>
                      <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="$store.state.option.document_type_register > 0 || $store.state.option.document_number_register > 0">
              <div class="form-row">
                <div class="col-md-6" v-if="$store.state.option.document_type_register > 0">
                  <div class="form-label-group">
                    <select id="document_Type" class="form-control" required="required" v-model="registar.document_Type" style="height:50px;">
                      <option value="" selected hidden>{{$store.state.option['document_Type-' + lang]}}*</option>
                      <option value="0">{{$store.state.option['document_Type-0-' + lang]}}</option>
                      <option value="1">{{$store.state.option['document_Type-1-' + lang]}}</option>
                      <option value="2">{{$store.state.option['document_Type-2-' + lang]}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6" v-if="$store.state.option.document_number_register > 0">
                  <div class="form-label-group">
                    <input type="text" id="document_Number" class="form-control" :placeholder="$store.state.option['document_Number-' + lang]" required="required" v-model="registar.document_Number" />
                    <label for="document_Number">{{$store.state.option['document_Number-' + lang]}}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="$store.state.option.document_Place_register > 0">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-label-group">
                    <select id="country" class="form-control" required="required" v-model="registar.document_Place" style="height:50px;">
                      <option value="" selected hidden>{{$store.state.option['document_Place-' + lang]}}*</option>
                      <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="$store.state.option.phone_Number_register > 0 || $store.state.option.mobile_Number_register > 0">
              <div class="form-row">
                <div class="col-md-6" v-if="$store.state.option.phone_Number_register > 0">
                  <div class="form-label-group">
                    <input type="text" id="phone_Number" class="form-control" :placeholder="$store.state.option['phone_Number-' + lang]" required="required" v-model="registar.phone_Number" />
                    <label for="phone_Number">{{$store.state.option['phone_Number-' + lang]}}</label>
                  </div>
                </div>
                <div class="col-md-6" v-if="$store.state.option.mobile_Number_register > 0">
                  <div class="form-label-group">
                    <input type="text" id="mobile_Number" class="form-control" :placeholder="$store.state.option['mobile_Number-' + lang]" required="required" v-model="registar.mobile_Number" />
                    <label for="mobile_Number">{{$store.state.option['mobile_Number-' + lang]}}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-label-group">
                <input type="email" id="inputEmail" class="form-control" :placeholder="$store.state.option['email1sf23-' + lang]" required="required" v-model="registar.email" />
                <label for="inputEmail">{{$store.state.option['email1sf23-' + lang]}}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="password" id="inputPassword" class="form-control" :placeholder="$store.state.option['senha332-' + lang]" required="required" v-model="registar.password"/>
                    <label for="inputPassword">{{$store.state.option['senha332-' + lang]}}</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="password" id="confirmPassword" class="form-control" :placeholder="$store.state.option['senha123f-' + lang]" required="required" @keydown.enter.prevent="submit" v-model="registar.password1" />
                    <label for="confirmPassword">{{$store.state.option['senha123f-' + lang]}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="$store.state.option.email_Notification_register > 0">
              <label for="email_Notification">{{$store.state.option['conta_pessoal_user-email_Notification-' + lang]}}</label>
              <input style="margin-left:10px;" id="email_Notification" v-model="registar.email_Notification" type="checkbox">
            </div>

          <a class="btn btn-primary btn-block btn-lg mao text-uppercase" @click="registarFN()" href="javascript:void(0)">{{$store.state.option['registarCont1-' + lang]}}</a>
          <div class="clearfix"></div>
        </div>
      </div>
    </modal>
    <modal name="cartao-modal" height="auto" maxwidth="600">
      <div class="col-md-12 col-xs-12" style="margin-bottom: 15px;">
        <h2 class="text-center" style="margin-top:15px;">{{$store.state.option['reserved-dadoscartao-' + lang]}}</h2>
        <div class="form-group">
            <div class="form-group m-0">
              <div class="form-row">
                <div class="col-md-12" style="margin-bottom:10px;">
                  <div class="form-label-group">
                    <input type="text" v-mask="'#### #### #### #?#?#?# ?#?#?#'" id="cartaonumero" class="form-control" :placeholder="$store.state.option['reserved-cartaonumero-' + lang]" required="required" autofocus="autofocus" v-model="cartao.CreditCardNumber" />
                    <label for="cartaonumero">{{$store.state.option['reserved-cartaonumero-' + lang]}}</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="text" id="cartaonome" class="form-control" :placeholder="$store.state.option['reserved-cartaonome-' + lang]" required="required" autofocus="autofocus" v-model="cartao.CreditCardName" />
                    <label for="cartaonome">{{$store.state.option['reserved-cartaonome-' + lang]}}</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="text" v-mask="'##/####'" id="cartaodata" :min="minDataCartao" class="form-control" :placeholder="$store.state.option['reserved-cartaodata-' + lang]" required="required" autofocus="autofocus" v-model.trim="cartao.CreditCardDueDate"  />
                    <label for="cartaodata">{{$store.state.option['reserved-cartaodata-' + lang]}}</label>
                  </div>
                </div>
              </div>
            </div>

          <a class="btn btn-default float-left btn-lg mao text-uppercase" style="margin-top:10px;" @click="$modal.hide('cartao-modal')" href="javascript:void(0)">{{$store.state.option['reserved-cancelar-' + lang]}}</a>
          <a class="btn btn-primary float-right btn-lg mao text-uppercase" style="margin-top:10px;" @click="cartaoFNRegisto()" href="javascript:void(0)">{{$store.state.option['reserved-cartaoguardar-' + lang]}}</a>
          <div class="clearfix"></div>
        </div>
      </div>
    </modal>
    <modal name="extra-obs-modal" height="auto" maxwidth="600">
      <div class="col-md-12 col-xs-12" style="margin-bottom: 15px;">
        <h2 class="text-center" style="margin-top:15px;">{{$store.state.option['extra-' + this.observationExtraId + '-tit-' + lang]}}</h2>
        <div class="form-group">
          <div class="form-group m-0">
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-label-group">
                  <p>{{$store.state.option['extra-' + this.observationExtraId + '-observations-' + lang]}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <titulo></titulo>
<!-- STEPS BUTTONS (passos)  -->
    <div class="b-laranja p-10">
      <div class="container">
        <div class="row">
          <div :class="{'quadrado text-justify pr col-md-3 col-lg-3 col-sm-12 col-xs-12 p-0' : 1, 'mao': passo}" @click="passo = 0;">
            <div class="seta b-laranja"></div>
            <div class="p-20 b-branco quadrado1 m-r-10">
              <div class="branco redondo b-laranja">01</div> {{$store.state.option['reserved-escolhaCarro-' + lang]}}
            </div>
          </div>
          <div :class="{'quadrado text-justify pr col-md-3 col-lg-3 col-sm-12 col-xs-12 p-0': 1, 'disabled1': !passo}">
            <div class="seta b-laranja"></div>
            <div class="p-20 b-branco quadrado1 m-r-10">
              <div class="branco redondo b-laranja">02</div> {{$store.state.option['reserved-detalhesReserva-' + lang]}}
            </div>
          </div>
          <div :class="{'quadrado text-justify pr col-md-3 col-lg-3 col-sm-12 col-xs-12 p-0': 1, 'disabled1': passo !== 2}" v-if="$store.state.user.role !== 'client'">
            <div class="seta b-laranja"></div>
            <div class="p-20 b-branco quadrado1 m-r-10">
              <div class="branco redondo b-laranja">03</div> {{$store.state.option['reserved-pagamento-' + lang]}}
            </div>
          </div>
          <div :class="{'quadrado text-justify pr col-md-3 col-lg-3 col-sm-12 col-xs-12 p-0': 1, 'disabled1': ($store.state.user.role !== 'client' && passo !== 3) || ($store.state.user.role === 'client' && passo !== 2)}">
            <div class="p-20 b-branco quadrado1 m-r-10">
              <div class="branco redondo b-laranja" v-text="$store.state.user.role != 'driver' ? '03' : '04'"></div> {{$store.state.option['reserved-boaViagem-' + lang]}}
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
    </div>

    <hr />

    <div class="container m-t-20" v-if="!passo || passo == 1">
      <div class="row">
        <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12">
          <h5>{{$store.state.option['reserved-onde-' + lang]}}</h5>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12">
              <span class="laranja">{{$store.state.option['levantamento-' + lang]}}</span>
              <select class="form-control" v-model="form.levantamento" @change="form.entrega = form.levantamento">
                <option value="" disabled selected hidden>{{$store.state.option['levantamento-' + lang]}}</option>
                <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
              </select>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12">
              <span class="laranja">{{$store.state.option['devolucao-' + lang]}}</span>
              <select class="form-control" v-model="form.entrega">
                <option value="" disabled selected hidden>{{$store.state.option['devolucao-' + lang]}}</option>
                <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12">
          <h5>{{$store.state.option['reserved-quando-' + lang]}}</h5>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
              <span class="laranja">{{$store.state.option['levantamento-' + lang]}}</span>
              <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                  <date-picker value-type="timestamp" required v-model="form.date" @change="handleChangeDate" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :disabled-date="notBeforeDate" :lang="langData" :placeholder="$store.state.option['levantamento_data-' + lang]"></date-picker>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                  <date-picker required v-model="form.time" :open.sync="open" @change="handleChange" :clearable="false" :editable="false" type="time" format="HH:mm" :minute-step="10" :placeholder="$store.state.option['levantamento_hora-' + lang]"></date-picker>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
              <span class="laranja">{{$store.state.option['devolucao-' + lang]}}</span>
              <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                  <date-picker value-type="timestamp" required v-model="form.date1" :disabled-date="notBeforeDate1" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :lang="langData" :placeholder="$store.state.option['devolucao_data-' + lang]"></date-picker>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                  <date-picker required v-model="form.time1" :clearable="false" :editable="false" type="time" format="HH:mm" :minute-step="10" :placeholder="$store.state.option['devolucao_hora-' + lang]" :open.sync="open1" @change="handleChange1"></date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="m-t-20 row">
        <div class="col-md-3 col-lg-3 col-sm-6 col-xs-12" v-if="$store.state.user">
            <span class="laranja" v-if="$store.state.user.role === 'client'">{{$store.state.option['reserved-seleccionarCondutor-' + lang]}}</span>
            <select id="driver" @change="driverFN1()" v-model="driver" class="form-control" v-if="$store.state.user.role === 'client'">
              <option hidden selected value="searchFN(1)">{{$store.state.option['reserved-seleccionarCondutor-' + lang]}}</option>
              <option :value="dt.DriverID" v-for="(dt, index) in drivers" :key="index">{{dt.Driver_Name}} ({{dt.City}})</option>
              <option value="add">{{$store.state.option['reserved-add-driver-' + lang]}}</option>
            </select>
        </div>

        <div class="col-md-3 col-lg-3 col-sm-6 col-xs-12" v-if="driver === 'add'">
            <span class="laranja">{{$store.state.option['reserved-nome-condutor-' + lang]}}</span>
            <input type="text" class="form-control" v-model="condutor" />
        </div>

        <div class="col-md-3 col-lg-3 col-sm-6 col-xs-12" v-if="!$store.state.user || driver === 'add'">
            <span class="laranja">{{$store.state.option['aniversario-' + lang]}}</span>
            <input type="text" id="date_of_Birth" class="form-control" :placeholder="$store.state.option['date_of_Birth-' + lang]" required="required" autofocus="autofocus" v-model="aniversario" v-mask="date_mask_local" @change="searchFN(1)"/>
        </div>

        <div :class="{'col-md-9 col-lg-9': driver === 'add' && !$store.state.user, 'col-md-3 col-lg-3': driver === 'add', 'col-sm-6 col-xs-12': 1}">
          <button class="btn btn-primary btn-block" id="pesqReserva" style="margin-top:24px;" @click="searchFN(1)">{{$store.state.option['search_botao-' + lang]}} <i class="fas fa-search m-l-15"></i></button>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="clearfix"></div>

    <div class="container" v-if="!passo">
      <div class="row p-v-20">
        <div :class="{'col-md-12 m-b-20': 1 , 'b-cinzento': index % 2}" style="border: solid 1px rgb(242,242,242);" v-for="(dt, index) in res" :key="index">
          <div class="row">
            <div class="col-lg-9 col-md-8 col-sm-6 col-xs-6">
              <div class="p-20">
                <h3>{{dt.group.brand}} {{dt.group.model}} <small>{{$store.state.option['similar-' + lang]}}</small></h3>
                <p class="laranja">{{dt.group_Name}}</p>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
                    <img :src="dt.imageURL ? dt.imageURL : '/img/img.png'" :alt="dt.car.brand + ' ' + dt.car.model" style="max-height:150px" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-b-20">
                    <div class="text-left p-t-20">
                      <span class="car-icon1 car-icon-margem laranja bg-icon_driver">  {{dt.group.seats}}</span>
                      <span class="car-icon1 car-icon-margem laranja bg-icon_door"> {{dt.group.doors}}</span>
                      <span class="car-icon1 car-icon-margem laranja bg-icon_bag"> {{dt.group.suitcases}}</span>
                      <span class="car-icon1 car-icon-margem laranja bg-icon_transmissao"> <span class="text-uppercase" v-html="dt.group.automaticTransmission == true ? $store.state.option['automatic-' + lang][0] : $store.state.option['manual-' + lang][0]"></span></span>
                    </div>
                  </div>
                  <p class="text-justify m-t-20">{{dt.group.details}}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-8 col-sm-6 col-xs-6 text-center b-cinzento">
              <p class="m-t-30">{{$store.state.option['reserved-reservarPor-' + lang]}}</p>
              <h3 :class="{'laranja': 1, 'risco': dt.previewValueWithDiscount < dt.previewValue}">{{$store.state.option.moeda1}} {{dt.previewValue}}</h3>
              <h3 class="danger" v-if="dt.previewValueWithDiscount < dt.previewValue">{{$store.state.option.moeda1}} {{dt.previewValueWithDiscount}}</h3>
              <button class="btn btn-primary btn-block text-uppercase m-t-20" @click="avancarFN(dt)">{{$store.state.option['car_reservar-' + lang]}} <i class="far fa-check-circle"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- EXTRAS - step 2, extras selection, res creation (v1) -->
    <div class="container" v-if="passo === 1">
      <div class="row p-v-20">
        <div class="col-md-12 m-b-20 p-b-20 p-t-20">
          <div class="row">
            <div class="col-lg-9 col-md-8 col-sm-6 col-xs-6">
              <h3>{{passoDta.group.brand}} {{passoDta.group.model}} <small>{{$store.state.option['similar-' + lang]}}</small></h3>
              <p class="laranja">{{passoDta.group_Name}}</p>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
                  <img :src="passoDta.imageURL ? passoDta.imageURL : '/img/img.png'" :alt="passoDta.group.brand + ' ' + passoDta.group.model" style="max-height:150px" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-b-20">
                  <div class="text-left p-t-20">
                    <span class="car-icon1 car-icon-margem laranja bg-icon_driver">  {{passoDta.group.seats}}</span>
                    <span class="car-icon1 car-icon-margem laranja bg-icon_door"> {{passoDta.group.doors}}</span>
                    <span class="car-icon1 car-icon-margem laranja bg-icon_bag"> {{passoDta.group.suitcases}}</span>
                    <span class="car-icon1 car-icon-margem laranja bg-icon_transmissao"> <span class="text-uppercase" v-html="passoDta.group.automaticTransmission == true ? $store.state.option['automatic-' + lang][0] : $store.state.option['manual-' + lang][0]"></span></span>
                  </div>
                </div>
                <p class="text-justify">{{passoDta.group.details}}</p>
                <div class="clearfix"></div><br />
                <div style="padding:5px 5px 0px 5px;">
                  <div class="row">
                    <div class="col-lg-12 m-t-20">
                      <div class="full-width p-t-20">
                        <h4 class="laranja">{{$store.state.option['kilometers-' + lang]}}</h4>
                        <span v-if="passoDta.kmsIncluded.toString() == 'true'">
                            <p>{{$store.state.option['reserved-incluido-' + lang]}}</p>
                        </span>
                        <span v-else-if="passoDta.kmsByDay.toString() == 'true'">
                            <p>{{passoDta.kmsFreePerDay}} {{$store.state.option['free_kms_per_day-' + lang]}}<span v-if="passoDta.kmsValue > 0">, {{$store.state.option['additional_kms_value-' + lang]}}: {{$store.state.option.moeda1}} {{passoDta.kmsValue}}</span></p>
                        </span>
                        <span v-else-if="passoDta.kmsByDay.toString() == 'false' && passoDta.kmsValue > 0">
                          <p>{{$store.state.option['kms_value-' + lang]}}: {{$store.state.option.moeda1}} {{passoDta.kmsValue}}</p>
                        </span>
                      </div>
                    </div>
                    <div class="col-lg-12 m-t-20"><h3 class="laranja">{{$store.state.option['reserved-extras-' + lang]}}</h3></div>
                      <div @click="addQuantidade(dt)" :class="{'col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center p-b-20 p-t-20': 1, 'checkbox mao': dt.accept_quantity == 'false', 'oculto': !($store.state.option['extra-' + dt.extraID + '-show-' + lang] > 0) || dt.extrasIncluded || dt.extrasRequired}" v-for="(dt, index) in passoDta.allExtras" :key="index" style="border-bottom: solid 1px #ccc">
                        <!--dt.extrasIncluded || dt.extrasRequired-->

                        <div style="border: solid 1px rgb(195,195,195);height:160px; margin-bottom:10px;background:#fff;padding:5px" class="text-center">
                          <img style="max-width: 100%; max-height:150px;" :src="'/images/' + $store.state.option['extra-' + dt.extraID + '-img-' + lang]" :alt="$store.state.option['extra-' + dt.extraID + '-tit-' + lang]" />
                        </div>
                        <h4 class="laranja">{{$store.state.option['extra-' + dt.extraID + '-tit-' + lang]}}</h4>
                        <p class="text-justify">{{$store.state.option['extra-' + dt.extraID + '-desc-' + lang]}}. <span v-if="$store.state.option['extra-' + dt.extraID + '-observations-' + lang]" class="laranja" v-on:click="activateObservationModel(dt.extraID)" >+ {{$store.state.option['extras-more-info-' + lang].toLowerCase()}}</span></p>
                        <h3>{{$store.state.option.moeda1}} {{parseFloat(dt.value * (dt.taxRate / 100 + 1) || 0).toFixed(2)}} <span v-if="dt.extraByDay === 'true'">({{$store.state.option['reserved-dia-' + lang]}})</span></h3>
                        <p v-if="dt.excess > 0">{{$store.state.option['reserved-valor_franquia-' + lang]}} {{$store.state.option.moeda1}} {{dt.excess}}</p>
                        <div v-if="dt.accept_quantity == 'true'" style="max-width:160px; margin: 0 auto;">
                          <div class="form-group">
                            <label class="sr-only">{{$store.state.option['reserved-quantidade-' + lang]}}</label>
                            <div class="input-group">
                              <div class="input-group-addon"><button :disabled="dt.extrasRequired || dt.extrasIncluded || dt.extrasAccepted" class="btn btn-primary" @click="dt.quant = dt.quant - 1 > 0 ? dt.quant - 1 : 0;">-</button></div>
                              <input :disabled="dt.extrasRequired || dt.extrasIncluded || dt.extrasAccepted" type="text" class="form-control text-center" :placeholder="$store.state.option['reserved-quantidade-' + lang]" min="0" v-model="dt.quant" />
                              <div class="input-group-addon"><button :disabled="dt.extrasRequired || dt.extrasIncluded || dt.extrasAccepted" class="btn btn-primary" @click="++dt.quant;">+</button></div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <label>
                            <input type="checkbox" value="1" v-model="dt.quant" :disabled="dt.extrasRequired || dt.extrasIncluded || dt.extrasAccepted" />
                          </label>
                        </div>
                      </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6 text-center b-cinzento">
              <p class="m-t-30">{{$store.state.option['reserved-reservarPor-' + lang]}} {{dias}} <span v-if="dias> 1">{{$store.state.option['reserved-dias-' + lang]}}</span><span v-else>{{$store.state.option['reserved-dia-' + lang]}}</span></p>
              <!--<h3 :class="{'laranja': 1, 'risco': previewValueWithDiscount < passoDta.previewValue}">{{$store.state.option.moeda1}} {{passoDta.previewValue}}</h3>
              <h3 class="danger" v-if="previewValueWithDiscount < passoDta.previewValue">{{$store.state.option.moeda1}} {{passoDta.previewValueWithDiscount}}</h3>-->
              <h3 class="laranja">{{$store.state.option.moeda1}} {{totalSemExtras}}</h3>

              <div style="background:#fff;padding:10px; margin: 20px 0px;">
                <div v-for="(dt, index) in passoDta.allExtras" :key="index">
                  <div style="margin: 5px; border-bottom:solid 1px #ccc;" v-if="dt.quant > 0 || dt.extrasIncluded || dt.extrasRequired">
                    <!--|| dt.extrasIncluded || dt.extrasRequired-->
                    <div class="text-left"><span v-if="dt.accept_quantity == 'true'">{{dt.quant || 1}}x </span> {{$store.state.option['extra-' + dt.extraID + '-tit-' + lang]}}</div>
                    <div class="clearfix"></div>
                    <span class="float-right" v-if="dt.extrasIncluded">{{$store.state.option['reserved-incluido-' + lang]}}</span>
                    <span class="laranja float-right" v-else>
                      <span v-if="dt.extraByDay !== 'true'">{{$store.state.option.moeda1}} {{parseFloat(dt.value * dt.quant * (dt.taxRate / 100 + 1)).toFixed(2)}}</span>
                      <span v-else>({{$store.state.option.moeda1}} {{parseFloat(dt.value * (dt.taxRate / 100 + 1) || 0).toFixed(2)}} {{$store.state.option['reserved-dia-' + lang]}})</span>
                    </span>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>

              <p v-if="logindriver === 2">{{$store.state.option['reserved-nome-condutor-' + lang]}}: {{condutor}}</p>
              <p v-if="logindriver === 2">{{$store.state.option['email2333-' + lang]}}: {{email}}</p>
              <p v-if="logindriver === 2 && $store.state.option.address_register1 > 0">{{$store.state.option['address-' + lang]}}: {{registar.address}}</p>
              <p v-if="logindriver === 2 && $store.state.option.postal_Code_register1 > 0">{{$store.state.option['postal_Code-' + lang]}}: {{registar.postal_Code}}</p>
              <p v-if="logindriver === 2 && $store.state.option.city_register1 > 0">{{$store.state.option['city-' + lang]}}: {{registar.city}}</p>
              <p v-if="logindriver === 2 && $store.state.option.city_regicountry1ster1 > 0">{{$store.state.option['country-' + lang]}}: {{registar.country}}</p>
              <p v-if="logindriver === 2 && $store.state.option.license_Number_register1 > 0">{{$store.state.option['license_Number-' + lang]}}: {{registar.license_Number}}</p>
              <p v-if="logindriver === 2 && $store.state.option.passportNumber1 > 0 && registar.passportNumber">{{$store.state.option['passportNumber-' + lang]}}: {{registar.passportNumber}}</p>
              <p v-if="logindriver === 2 && $store.state.option.idNumber1 > 0 && registar.idNumber">{{$store.state.option['idNumber-' + lang]}}: {{registar.idNumber}}</p>
              <p v-if="logindriver === 2 && $store.state.option.taxNumber1 > 0">{{$store.state.option['tax_number-' + lang]}}: {{registar.tax_number}}</p>
              <p v-if="logindriver === 2 && $store.state.option.phone_Number_register1 > 0">{{$store.state.option['phone_Number-' + lang]}}: {{registar.phone_Number}}</p>
              <p v-if="logindriver === 2 && $store.state.option.mobile_Number_register1 > 0">{{$store.state.option['phone_Number-' + lang]}}: {{registar.mobile_Number}}</p>
              <div class="clearfix"></div>
              <a v-if="logindriver === 2" @click="$modal.show('guest-modal');" class="float-right btn btn-warning btn-block text-white m-b-10">{{$store.state.option['edit-dados-guest-' + lang]}}</a>
              <div class="clearfix"></div>

              <div class="clearfix"></div>
              <div class="text-left text-uppercase">{{$store.state.option['reserved-total-' + lang]}}</div>
              <h2 class="text-danger text-right" style="text-decoration: line-through;" v-if="total < total1 && total > 0">{{$store.state.option.moeda1}} {{total1}}</h2>
              <div v-if="total > 0">
                <h2 class="laranja text-right" v-if="total > 0">{{$store.state.option.moeda1}} {{total}}</h2>
                <!--<h2 class="laranja text-right" v-if="totalSIVA > 0 && !($store.state.option.iva > 0)">{{$store.state.option.moeda1}} {{totalSIVA}}</h2>-->
              </div>
              <h6 class="text-right" v-else>Loading&#8230;</h6>
              <p class="text-right" v-if="($store.state.option.iva > 0)">{{$store.state.option['reserved-totalciva-' + lang]}}</p>
              <p class="text-right" v-else>{{$store.state.option['reserved-totalsiva-' + lang]}}</p>

              <div class="clearfix"></div>

              <div class="form-check m-t-20" v-if="$store.state.option['reserved-confirmacao1-' + lang]">
                <input class="form-check-input" type="checkbox" id="confirmacao1" :disabled="!this.total" v-model="form1.confirmacao1">
                <label class="form-check-label" for="confirmacao1" v-html="$store.state.option['reserved-confirmacao1-' + lang]"></label>
              </div>
              <div class="form-check" v-if="$store.state.option['reserved-confirmacao2-' + lang]">
                <input class="form-check-input" type="checkbox" id="confirmacao2" :disabled="!this.total" v-model="form1.confirmacao2">
                <label class="form-check-label" for="confirmacao2" v-html="$store.state.option['reserved-confirmacao2-' + lang]"></label>
              </div>
              <div class="form-check" v-if="$store.state.option['reserved-confirmacao3-' + lang]">
                <input class="form-check-input" type="checkbox" id="confirmacao3" :disabled="!this.total" v-model="form1.confirmacao3">
                <label class="form-check-label" for="confirmacao3" v-html="$store.state.option['reserved-confirmacao3-' + lang]"></label>
              </div>

              <button v-if="$store.state.user || logindriver === 2" :disabled="!(($store.state.option['reserved-confirmacao1-' + lang] && form1.confirmacao1 || !$store.state.option['reserved-confirmacao1-' + lang]) && ($store.state.option['reserved-confirmacao2-' + lang] && form1.confirmacao2 || !$store.state.option['reserved-confirmacao2-' + lang]) && ($store.state.option['reserved-confirmacao3-' + lang] && form1.confirmacao3 || !$store.state.option['reserved-confirmacao3-' + lang]))" class="btn btn-primary m-t-20 text-uppercase btn-block d-none d-md-block" @click="avancarFN1()">{{$store.state.option['reserved-confirmar-reserva-' + lang]}}<i class="fas fa-arrow-circle-right"></i></button>

              <button :disabled="!($store.state.option['reserved-confirmacao1-' + lang] && form1.confirmacao1 && (!$store.state.option['reserved-confirmacao2-' + lang] || $store.state.option['reserved-confirmacao2-' + lang] && form1.confirmacao2) && (!$store.state.option['reserved-confirmacao3-' + lang] || $store.state.option['reserved-confirmacao3-' + lang] && form1.confirmacao3))" v-else class="btn btn-primary m-t-20 m-b-20 text-uppercase btn-block d-none d-md-block" @click="logar()">{{$store.state.option['reserved-entrar-criar-conta-' + lang]}}<i class="fas fa-arrow-circle-right"></i></button>

              <div class="clearfix"></div>

              <input type="text" class="form-control m-t-20" v-model="code" :placeholder="$store.state.option['reserved-promotion-code1-' + lang]" />
              <button class="btn btn-block btn-primary" style="margin-top:7px;" @click="totalFN()">{{$store.state.option['reserved-promotion-code-' + lang]}}</button>
              <div class="clearfix"></div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- SUMMARY - step 3, payment/confirmation -->
    <div class="container m-b-20 m-t-20" v-if="passo === 2">
      <h3 v-if="$store.state.user.role === 'client'" class="text-uppercase">{{ $store.state.option['reserved-sumarioReserva-' + lang] }} <span class="laranja">{{reserva.Reservation_Nr}}</span></h3>
      <h3 v-else class="text-uppercase">{{ $store.state.option['reserved-sumarioReserva-driver-' + lang] }}</h3>

      <a downlaod v-if="$store.state.user.role === 'client'" :href="'/pdf/' + reserva.Reservation_Nr + '/' + reserva.token + '?language=' + lang" class="float-right btn btn-warning">{{$store.state.option['reserved-download-pdf-' + lang]}}</a>
      <div class="clearfix"></div>
      <!--<h2 class="text-success text-justify p-20" style="padding-left:0px;">{{$store.state.option['reserved-reserva-sucesso-n-' + lang]}} <span class="laranja">{{reserva.Reservation_Nr}}</span>.</h2>-->

      <div class="row">
        <div class="col-lg-9 col-md-8 col-sm-6 col-xs-6">
          <h3>{{passoDta.group.brand}} {{passoDta.group.model}} <small>{{$store.state.option['similar-' + lang]}}</small></h3>
          <!--<button class="float-right btn btn-warning">{{$store.state.option['reserved-download-pdf-' + lang]}}</button>-->
          <p class="laranja">{{passoDta.group_Name}}</p>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
              <img :src="passoDta.imageURL ? passoDta.imageURL : '/img/img.png'" :alt="passoDta.group.brand + ' ' + passoDta.group.model" style="max-height:150px; max-width:100%;" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-b-20">
              <div class="text-left p-t-20">
                <span class="car-icon1 car-icon-margem laranja bg-icon_driver">  {{passoDta.group.seats}}</span>
                <span class="car-icon1 car-icon-margem laranja bg-icon_door"> {{passoDta.group.doors}}</span>
                <span class="car-icon1 car-icon-margem laranja bg-icon_bag"> {{passoDta.group.suitcases}}</span>
                <span class="car-icon1 car-icon-margem laranja bg-icon_transmissao"> <span class="text-uppercase" v-html="passoDta.group.automaticTransmission == true ? $store.state.option['automatic-' + lang][0] : $store.state.option['manual-' + lang][0]"></span></span>
              </div>
            </div>
            <div><p class="text-justify m-t-20">{{passoDta.group.details}}</p></div>
            <hr />
            <div class="full-width p-t-20">
              <h4 class="laranja">{{$store.state.option['kilometers-' + lang]}}</h4>
              <span v-if="passoDta.kmsIncluded.toString() == 'true'">
                <p>{{$store.state.option['reserved-incluido-' + lang]}}</p>
              </span>
              <span v-else-if="passoDta.kmsByDay.toString() == 'true'">
                <p>{{passoDta.kmsFreePerDay}} {{$store.state.option['free_kms_per_day-' + lang]}}<span v-if="passoDta.kmsValue > 0">, {{$store.state.option['additional_kms_value-' + lang]}}: {{$store.state.option.moeda1}} {{passoDta.kmsValue}}</span></p>
              </span>
              <span v-else-if="passoDta.kmsByDay.toString() == 'false' && passoDta.kmsValue > 0">
                <p>{{$store.state.option['kms_value-' + lang]}}: {{$store.state.option.moeda1}} {{passoDta.kmsValue}}</p>
              </span>
            </div>
            <div class="full-width">
                <h3 class="laranja">{{$store.state.option['reserved-extras-' + lang]}}</h3>
                <!--!! ADD 0 EXCESS here when full coverage is selected -->
                <div class="full-width" v-for="(dt, index) in passoDta.allExtras" :key="index">
                  <div  v-if="dt.quant > 0 || dt.extrasIncluded">
                    <div class="text-left">
                      <span v-if="dt.accept_quantity == 'true'">{{dt.quant || 1}}x </span>{{$store.state.option['extra-' + dt.extraID + '-tit-' + lang]}}<br />
                    </div>
                  </div>
                </div>
            </div>
            <hr />
            <div class="full-width p-t-20">
              <h3 class="laranja">{{$store.state.option['reserved-condutor-' + lang]}}</h3>
              <p>{{ condutor }}</p>

              <h3 class="laranja">{{$store.state.option['reserved-suamrio-reserva-' + lang]}}</h3>
              <p><b>{{$store.state.option['reserved-dias-' + lang]}}:</b> {{passoDta.nrDays}} </p>
              <p><b>{{$store.state.option['reserved-suamrio-levantamento-' + lang]}}:</b> {{ estacoes.find(a => a.StationID == form.levantamento).Station }}, {{setDatesFormat(datasFim, 'checkout')}}</p>
              <p><b>{{$store.state.option['reserved-suamrio-devolucao-' + lang]}}:</b> {{ estacoes.find(a => a.StationID == form.entrega).Station }}, {{setDatesFormat(datasFim, 'checkin')}}</p>
            </div>

            <div class="full-width b-cinzento text-right p-t-20 p-b-20 m-t-30">
              <h2 class="text-uppercase">{{$store.state.option['reserved-total-' + lang]}}
                <span class="laranja" style="margin-left:20px;">{{$store.state.option.moeda1}} {{total}}</span>
                <!--<span v-else class="laranja" style="margin-left:20px;">{{$store.state.option.moeda1}} {{totalSIVA}}</span>-->
              </h2>
              <p class="text-right" v-if="($store.state.option.iva > 0)">{{$store.state.option['reserved-totalciva-' + lang]}}</p>
              <p class="text-right" v-else>{{$store.state.option['reserved-totalsiva-' + lang]}}</p>

            </div>
            <p v-if="$store.state.user.role === 'driver' || logindriver === 2" class="m-t-20" v-html="$store.state.option['reserved-descricao-final-pagamento-' + lang]"></p>
            <p v-else class="m-t-20" v-html="$store.state.option['reserved-descricao-final-pagamentoClient-' + lang]"></p>

          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6 text-center b-cinzento" v-if="$store.state.user.role === 'driver' || logindriver === 2">
          <div class="p-t-30 text-center" v-show="!!Number($store.state.option['showPaypalOption'])">
            <img alt="paypal" src="/img/paypal.png" style="max-width:90%" />
          </div>
          <div class="p-t-30 text-justify">
            <p><span v-html="$store.state.option['reserved-descricao-final-pagamentoXX-' + lang]"></span> <span class="laranja text-uppercase" v-html="$store.state.option['reserved-descricao-final-pagamento2-' + lang]"></span></p>
          </div>
          <hr/>

          <div class="text-left text-uppercase">{{$store.state.option['reserved-total-' + lang]}}</div>
          <h2 class="laranja text-right m-b-20" v-if="total">{{$store.state.option.moeda1}} {{total}}</h2>
          <!--<h2 class="laranja text-right m-b-20" v-if="totalSIVA && !($store.state.option.iva > 0)">{{$store.state.option.moeda1}} {{totalSIVA}}</h2>-->
          <p class="text-right" v-if="($store.state.option.iva > 0)">{{$store.state.option['reserved-totalciva-' + lang]}}</p>
          <p class="text-right" v-else>{{$store.state.option['reserved-totalsiva-' + lang]}}</p>
          <hr />

          <a @click="paypalFN()" class="btn btn-primary m-t-20 text-uppercase btn-block text-white" v-show="!!Number($store.state.option['showPaypalOption'])">Paypal <i class="fas fa-arrow-circle-right"></i></a>

          <button class="btn btn-primary m-t-20 text-uppercase btn-block" @click="$modal.show('cartao-modal')" v-show="!!Number($store.state.option['showReserveWithCardOption'])">{{$store.state.option['reserved-cartaocredito-' + lang]}}</button>
          <button class="btn btn-primary m-t-20 text-uppercase btn-block" @click="console.log('hello')" v-show="!!Number($store.state.option['showPayWithCreditCardOtpion'])">{{$store.state.option['reserved-cardDirectPayment-' + lang]}}</button>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import titulo from '@/components/titulo'
import birthDate from '../mixins/birthDate'

export default {
  components: { titulo },
  mixins: [birthDate],
  data () {
    return {
      res: [],
      lang: '',
      langData: {},
      estacoes: [],
      form: {
        levantamento: '',
        entrega: '',
        date: '',
        date1: '',
        time: new Date('2000/10/10 10:00:00'),
        time1: new Date('2000/10/10 10:00:00')
      },
      form1: {
        confirmacao1: '',
        confirmacao2: '',
        confirmacao3: ''
      },
      passo: '',
      passoDta: {},
      rateID: '',
      total: 0,
      total1: 0,
      totalSIVA: 0,
      totalSemExtras: 0,
      reserva: {},
      drivers: [],
      driver: '',
      open: false,
      open1: false,
      condutor: '',
      email: '',
      datasFim: {},
      dias: 1,
      code: '',
      aniversario: '',
      driverOK: false,
      form2: {
        email: '',
        password: ''
      },
      registar: {
        email: '',
        password: '',
        driver_Name: '',
        country: '',
        license_Place: '',
        document_Place: '',
        document_Type: 1,
        document_Number: '',
        mobile_Number: '',
        phone_Number: '',
        postal_Code: '',
        city: '',
        address: '',
        date_of_Birth: '',
        email_Notification: true,
        license_Country: '',
        tax_number: '',
        idNumber: '',
        license_Number: '',
        passportNumber: ''
      },
      cartao: {
        CreditCardDueDate: '',
        CreditCardName: '',
        CreditCardNumber: ''
      },
      minDataCartao: '',
      logindriver: 0, // fazer a reserva como guest
      paypal: false,
      observationExtraId: '',
      date_mask_local: '####-##-##',
      formattedBirthDate: '',
      birthDayFromMixin: ''
    }
  },
  watch: {
    form: {
      handler: function () {
        // this.searchFN()
        this.res = []
        this.passo = 0
      },
      deep: true
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.passo = ''
    this.passoDta = {}
    let a = decodeURIComponent(window.location.search || '')
    let x = {
      levantamento: (a.split('?l=')[1] || '').split('&')[0] || '',
      entrega: (a.split('&d=')[1] || '').split('&')[0] || '',
      date: a.split('&dt=')[1] ? new Date(a.split('&dt=')[1].split('&')[0] + ':00').getTime() : '',
      date1: a.split('&dt1=')[1] ? new Date(a.split('&dt1=')[1].split('&')[0] + ':00').getTime() : '',
      time: a.split('&dt=')[1] ? new Date(a.split('&dt=')[1].split('&')[0] + ':00') : new Date('2000/10/10 10:00:00'),
      time1: a.split('&dt1=')[1] ? new Date(a.split('&dt1=')[1].split('&')[0] + ':00') : new Date('2000/10/10 10:00:00')
    }
    let birthDateFromTheURL = a.split('&b=')[1] ? (a.split('&b=')[1].split('&')[0]).toString().replace(/\//g, '-') : ''
    this.aniversario = `${birthDateFromTheURL.split('-')[0]}-${('0' + (birthDateFromTheURL.split('-')[1])).slice(-2)}-${('0' + birthDateFromTheURL.split('-')[2]).slice(-2)}`
    if (a) {
      this.driver = a.split('&dd=')[1].split('&')[0] || ''
    }
    this.condutor = a.split('&cd=')[1] || ''
    this.form = x
    this.driverOK = 0
    this.init(a)
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_LOAD1',
      'SET_TITULO',
      'SET_SUBTITULO',
      'SET_AVISO',
      'SET_USER',
      'SET_TOAST'
    ]),
    notBeforeDateAniversario (date) {
      return date > new Date()
    },
    handleChangeDate () {
      let d = new Date(this.form.date)
      d.setDate(d.getDate() + 7)
      this.form.date1 = new Date(d).getTime()
    },
    handleChange (value, type) {
      if (type === 'minute') {
        this.open = false
      }
    },
    handleChange1 (value, type) {
      if (type === 'minute') {
        this.open1 = false
      }
    },
    notBeforeDate (date) {
      return date < new Date().setDate(new Date().getDate() - 1)
    },
    notBeforeDate1 (date) {
      return date < new Date(this.form.date)
    },
    setBirthDate () {
      this.formattedBirthDate = this.aniversario
      this.date_mask_local = this.$store.state.option.date_mask
      if (this.checkAndTransformBirthDate(this.aniversario)) {
        this.aniversario = this.birthDayFromMixin
      }
    },
    init (form) {
      if (this.$store.state.option1 && this.$store.state.stations1 && this.$store.state.cars1) {
        this.setBirthDate()
        this.lang = this.$store.state.lang
        this.code = ''
        this.SET_LOAD()
        this.SET_LOAD1(true)
        this.SET_TITULO(this.$store.state.option['reserved_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['reserved_subtitle-' + this.lang])
        this.langData = {
          days: [this.$store.state.option['sun-' + this.lang], this.$store.state.option['mon-' + this.lang], this.$store.state.option['tue-' + this.lang], this.$store.state.option['wed-' + this.lang], this.$store.state.option['thu-' + this.lang], this.$store.state.option['fri-' + this.lang], this.$store.state.option['sat-' + this.lang]],
          months: [this.$store.state.option['jan-' + this.lang], this.$store.state.option['fev-' + this.lang], this.$store.state.option['mar-' + this.lang], this.$store.state.option['apr-' + this.lang], this.$store.state.option['may-' + this.lang], this.$store.state.option['jun-' + this.lang], this.$store.state.option['jul-' + this.lang], this.$store.state.option['aug-' + this.lang], this.$store.state.option['sep-' + this.lang], this.$store.state.option['out-' + this.lang], this.$store.state.option['nov-' + this.lang], this.$store.state.option['dec-' + this.lang]]
        }
        if (this.$store.state.user) {
          if (this.$store.state.user.role === 'driver') {
            this.aniversario = this.$store.state.user.date_of_Birth
          } else if (this.$store.state.user.role === 'client') {
            if (this.$store.state.drivers1) {
              this.drivers = this.$store.state.drivers
              if (this.$store.state.option.date_format === 'DD-MM-YYYY' && this.aniversario.split('-')[0].length === 4) {
                this.aniversario = this.toggleISOandEUformat(this.aniversario)
              }
            } else {
              this._.delay(this.init, 100)
            }
          }
        }
        this.estacoes = this.$store.state.stations
        this.minDataCartao = new Date().getFullYear() + '-' + new Date().getMonth()

        if (this.$store.state.option.idNumber1 < 1) {
          this.registar.document_Type = 2
        }
        // HERE THEY SET DATES WHEN LOGGED WITH CLIENT (?)
        if (this.driver > 0) {
          let a = this.drivers.find(a => {
            return parseInt(a.DriverID) === parseInt(this.driver)
          }) || {}
          this.condutor = a.Driver_Name
          this.aniversario = a.Date_of_Birth
        }
        this.SET_LOAD1()
        if (form) {
          this.searchFN()
        }
      } else {
        this._.delay(this.init, 100)
      }
    },
    driverFN1 () {
      if (this.driver === 'add') {
        this.condutor = ''
        this.aniversario = ''
        this.res = []
      } else {
        let a = this.drivers.find(a => {
          return parseInt(a.DriverID) === parseInt(this.driver)
        })
        this.condutor = a.Driver_Name
        this.aniversario = a.Date_of_Birth
        this.searchFN(1)
      }
    },
    searchFN (x) {
      // if (this.$store.state.option.date_format === 'YYYY-MM-DD' && !/[12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])/.test(this.aniversario) && !this.$store.state.user) {
      //   this.SET_AVISO(this.$store.state.option['erro-aniversario_pattern-' + this.lang] || 'Please insert the birthday date with the following pattern: yyyy-mm-dd')
      //   return
      // }
      this.formattedBirthDate = this.aniversario
      // verify which date format is used in vuex:
      if (!this.checkAndTransformBirthDate(this.aniversario)) {
        return
      } else {
        this.aniversario = this.birthDayFromMixin
      }
      let a = new Date(this.form.date)
      let b = new Date(this.form.date1)
      let a1 = new Date(this.form.time)
      let b1 = new Date(this.form.time1)
      let x1 = 0
      if (this.$store.state.user) {
        if (this.$store.state.user.role === 'client') {
          x1 = 'c'
        }
        if (this.$store.state.user.role === 'driver') {
          x1 = 'd'
        }
      }
      let aniversario = new Date(this.formattedBirthDate)
      if (x) {
        if (this.form.levantamento) {
          if (this.form.date) {
            if (this.form.date1) {
              if ((((this.aniversario && this.driver === 'add') || (this.driver && this.driver !== 'add')) && x1 === 'c') || x1 === 'd' || (this.aniversario && !this.$store.state.user)) {
                this.$router.push('/reserved?l=' + this.form.levantamento + '&d=' + this.form.entrega + '&dt=' + a.getFullYear() + '/' + (+a.getMonth() + 1) + '/' + a.getDate() + ' ' + a1.getHours() + ':' + a1.getMinutes() + '&dt1=' + b.getFullYear() + '/' + (+b.getMonth() + 1) + '/' + b.getDate() + ' ' + b1.getHours() + ':' + b1.getMinutes() + '&b=' + aniversario.getFullYear() + '/' + (+aniversario.getMonth() + 1) + '/' + aniversario.getDate() + '&dd=' + this.driver, () => {})
                if (this.$store.state.user.role === 'driver') {
                  this.condutor = this.$store.state.user.Driver_Name || this.$store.state.user.driver_Name
                }
              } else {
                if (this.driver === 'add' || !this.$store.state.user) {
                  this.SET_AVISO(this.$store.state.option['erro-aniversario-' + this.lang])
                } else {
                  this.SET_AVISO(this.$store.state.option['erro-driver-' + this.lang])
                }
                return
              }
            } else {
              this.SET_AVISO(this.$store.state.option['erro-devolucaoData-' + this.lang])
              return
            }
          } else {
            this.SET_AVISO(this.$store.state.option['erro-levantamentoData-' + this.lang])
            return
          }
        } else {
          this.SET_AVISO(this.$store.state.option['erro-levantamento-' + this.lang])
          return
        }
      } else {
        if (!this.form.levantamento) {
          this.SET_LOAD1()
          return
        }
      }
      this.SET_LOAD1(true)
      this.passo = ''
      // confirmation checkboxes disabled when on passo = ''
      this.form1.confirmacao1 = ''
      this.form1.confirmacao2 = ''
      this.form1.confirmacao3 = ''
      this.axios.get('/quotes/multiple?' + (this.code ? 'promotionCode=' + this.code : '') + (this.aniversario ? '&Date_of_Birth=' + aniversario.getFullYear() + '-' + (+aniversario.getMonth() + 1) + '-' + aniversario.getDate() : '') + '&pickup_station=' + this.form.levantamento + '&dropoff_station=' + (this.form.entrega ? this.form.entrega : this.form.levantamento) + '&pickup_date=' + a.getFullYear() + '-' + this.addZero(+a.getMonth() + 1) + '-' + this.addZero(a.getDate()) + ' ' + this.addZero(a1.getHours()) + ':' + this.addZero(a1.getMinutes()) + '&dropoff_date=' + b.getFullYear() + '-' + this.addZero(+b.getMonth() + 1) + '-' + this.addZero(b.getDate()) + ' ' + this.addZero(b1.getHours()) + ':' + this.addZero(b1.getMinutes())).then((res) => {
        window.scrollTo(0, 0)
        window.scrollTo(0, document.querySelector('#pesqReserva').getBoundingClientRect().top + 38)
        this.logindriver = 0
        this.email = ''
        this.res = res.data.map(a => {
          a.car = this.$store.state.cars.find(x => a.groupID === x.groupID) || {}
          let extrasAccepted = a.extrasAccepted.split(',')
          let extrasIncluded = a.extrasIncluded.split(',')
          let extrasRequired = a.extrasRequired.split(',')
          let i
          if (a.package) {
            extrasIncluded = extrasIncluded.concat(a.package.split(','))
          }
          if (a.allExtras) {
            i = a.allExtras.length
            while (--i >= 0) {
              a.allExtras[i].extrasAccepted = extrasAccepted.find(xxx => xxx.trim() === a.allExtras[i].extraID.trim())
              a.allExtras[i].extrasIncluded = extrasIncluded.find(xxx => xxx.trim() === a.allExtras[i].extraID.trim())
              a.allExtras[i].extrasRequired = extrasRequired.find(xxx => xxx.trim() === a.allExtras[i].extraID.trim())
              a.allExtras[i].quant = a.allExtras[i].extrasRequired ? 1 : 0 || a.allExtras[i].extrasAccepted ? 1 : 0
            }
          }
          if (!a.group) {
            a.group = {}
          }
          return a
        })
        this.triggerDataLayer()
        this.SET_LOAD1()
      }, (er) => {
        this.res = []
        this.SET_AVISO(er.response.data.error)
      })
    },
    addZero (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    addQuantidade (dt) {
      if (dt.extrasAvailable || dt.extrasIncluded || dt.extrasRequired) {
        // nao tem click
      } else {
        if (dt.accept_quantity === 'false') {
          dt.quant = !dt.quant
        }
        this.totalFN()
      }
    },
    totalFN () {
      if (this.passoDta.groupID) {
        let a = new Date(this.form.date)
        let b = new Date(this.form.date1)
        let a1 = new Date(this.form.time)
        let b1 = new Date(this.form.time1)
        this.total = 0
        this.totalSIVA = 0
        this.totalSemExtras = 0
        this.total1 = 0
        let extras = []
        this.passoDta.allExtras.map(a => {
          if (a.quant > 0 && !(a.extrasIncluded || a.extrasAccepted || a.extrasRequired)) {
            let i = a.quant
            while (--i >= 0) {
              extras.push(a.extraID)
            }
          }
        })
        this.formattedBirthDate = this.aniversario
        // verify which date format is used in vuex:
        if (!this.checkAndTransformBirthDate(this.aniversario)) {
          return
        } else {
          this.aniversario = this.birthDayFromMixin
        }
        this.axios.get('/quotes?rateCode=' + this.passoDta.rateCode + (this.code ? '&promotionCode=' + this.code + '&' : '') + (this.aniversario ? '&Date_of_Birth=' + this.formattedBirthDate : '') + '&groupID=' + this.passoDta.groupID + '&pickup_station=' + this.form.levantamento + '&pickup_date=' + a.getFullYear() + '-' + this.addZero(+a.getMonth() + 1) + '-' + this.addZero(a.getDate()) + ' ' + this.addZero(a1.getHours()) + ':' + this.addZero(a1.getMinutes()) + '&dropoff_station=' + this.form.entrega + '&dropoff_date=' + b.getFullYear() + '-' + this.addZero(+b.getMonth() + 1) + '-' + this.addZero(b.getDate()) + ' ' + this.addZero(b1.getHours()) + ':' + this.addZero(b1.getMinutes()) + '&extras=' + extras.join(',') + (this.passoDta.package ? (extras.length ? ',' : '') + this.passoDta.package : '')).then((res) => {
          if (this.code && res.data[0].errorMessage) {
            this.code = ''
            this.SET_AVISO(res.data[0].errorMessage)
            this.totalFN()
          } else {
            if (res.data[0].errorMessage) {
              this.SET_AVISO(res.data[0].errorMessage)
            } else {
              this.rateID = res.data[0].rateID
              this.total = res.data[0].previewValueWithDiscount
              this.total1 = res.data[0].previewValue
              this.totalSIVA = res.data[0].valueWithoutTax
              this.dias = res.data[0].nrDays
              this.totalSemExtras = res.data[0].previewValueWithoutExtras
            }
          }
        }, (er) => {
          this.SET_AVISO(er.response.data.error)
        })
      }
    },
    avancarFN (dt) {
      this.SET_LOAD1(true)
      if (this.$store.state.user.role === 'client') {
        this.passoDta = dt
        this.totalFN()
        this.passo = 1
        window.scrollTo(0, 0)
        window.scrollTo(0, document.querySelector('#pesqReserva').getBoundingClientRect().top + 38)
        this.SET_LOAD1()
      } else {
        this.passoDta = dt
        this.totalFN()
        this.passo = 1
        window.scrollTo(0, 0)
        window.scrollTo(0, document.querySelector('#pesqReserva').getBoundingClientRect().top + 38)
        this.SET_LOAD1()
      }
    },
    avancarFN1 () {
      if (this.form1.confirmacao1 || !this.$store.state.option['reserved-confirmacao1-' + this.lang]) {
        if (this.form1.confirmacao2 || !this.$store.state.option['reserved-confirmacao2-' + this.lang]) {
          if (this.form1.confirmacao3 || !this.$store.state.option['reserved-confirmacao3-' + this.lang]) {
            if (this.$store.state.user.role === 'client') {
              if (this.driver === 'add') {
                // tou a criar driver
              } else {
                if (!this.driver) {
                  this.SET_AVISO(this.$store.state.option['reserved-escolha-condutor-' + this.lang])
                  document.querySelector('#driver').focus()
                  return
                }
              }
            }
            let extras = []
            this.passoDta.allExtras.map(a => {
              if (a.quant > 0 && !(a.extrasIncluded || a.extrasAccepted || a.extrasRequired)) {
                let i = a.quant
                while (--i >= 0) {
                  extras.push(a.extraID)
                }
              }
            })
            let a = new Date(this.form.date)
            let b = new Date(this.form.date1)
            let a1 = new Date(this.form.time)
            let b1 = new Date(this.form.time1)

            this.SET_LOAD1(true)
            if (this.$store.state.user.role === 'driver') {
              this.condutor = this.$store.state.user.Driver_Name || this.$store.state.user.driver_Name
            }
            this.formattedBirthDate = this.aniversario
            // verify which date format is used in vuex:
            if (!this.checkAndTransformBirthDate(this.aniversario)) {
              return
            } else {
              this.aniversario = this.birthDayFromMixin
            }
            let dta = {
              companyCode: this.$store.state.companyCode,
              customerCode: this.$store.state.customerCode,
              MessageType: 'N',
              Group: this.passoDta.groupID,
              Observations: '',
              // inAnalysis: 'True',
              Extras: extras.join(',') + (this.passoDta.package ? (extras.length ? ',' : '') + this.passoDta.package : ''),
              PickUp: {
                Date: a.getFullYear() + '-' + this.addZero(+a.getMonth() + 1) + '-' + this.addZero(a.getDate()) + ' ' + this.addZero(a1.getHours()) + ':' + this.addZero(a1.getMinutes()),
                Rental_Station: this.form.levantamento
              },
              DropOff: {
                Date: b.getFullYear() + '-' + this.addZero(+b.getMonth() + 1) + '-' + this.addZero(b.getDate()) + ' ' + this.addZero(b1.getHours()) + ':' + this.addZero(b1.getMinutes()),
                Rental_Station: this.form.entrega
              },
              RateCode: this.rateID,
              Driver: {
                Name: this.condutor,
                Date_of_Birth: this.formattedBirthDate
              },
              promotionCode: this.code,
              language: this.lang,
              kilometers: {
                kmsByDay: this.passoDta.kmsByDay,
                kmsFreePerDay: this.passoDta.kmsFreePerDay,
                kmsIncluded: this.passoDta.kmsIncluded,
                kmsValue: this.passoDta.kmsValue
              }
            }
            if (this.driver !== 'add' && this.logindriver !== 2) {
              dta.DriverID = this.$store.state.user.role === 'client' ? this.driver : this.$store.state.user.driverID || this.$store.state.user.DriverID
            }
            if (this.logindriver === 2) {
              if (!this.email) {
                this.SET_AVISO(this.$store.state.option['erro-email1-' + this.lang])
                return
              }
              if (!this.condutor) {
                this.SET_AVISO(this.$store.state.option['reserved-escolha-condutor-' + this.lang])
                return
              }
              if (this.$store.state.option.country1 > 0) {
                if (!this.registar.country) {
                  this.SET_AVISO(this.$store.state.option['erro-country_register-' + this.lang])
                  return
                }
              }
              if (this.$store.state.option.address_register1 > 0) {
                if (!this.registar.address) {
                  this.SET_AVISO(this.$store.state.option['erro-address_register-' + this.lang])
                  return
                }
              }
              if (this.$store.state.option.postal_Code_register1 > 0) {
                if (!this.registar.postal_Code) {
                  this.SET_AVISO(this.$store.state.option['erro-postal_Code_register-' + this.lang])
                  return
                }
              }
              if (this.$store.state.option.city_register1 > 0) {
                if (!this.registar.city) {
                  this.SET_AVISO(this.$store.state.option['erro-city_register-' + this.lang])
                  return
                }
              }
              if (!((this.registar.license_Number && this.$store.state.option.license_Number_register1 > 0) || (this.registar.idNumber && this.$store.state.option.idNumber1 > 0) || (this.registar.passportNumber && this.$store.state.option.passportNumber1 > 0))) {
                if (this.$store.state.option.license_Number_register1 > 0) {
                  if (!this.registar.license_Number) {
                    this.SET_AVISO(this.$store.state.option['erro-license_Number_register-' + this.lang])
                    return
                  }
                }
                if (this.$store.state.option.idNumber1 > 0) {
                  if (!this.registar.idNumber) {
                    this.SET_AVISO(this.$store.state.option['erro-idNumber_register-' + this.lang])
                    return
                  }
                }
                if (this.$store.state.option.passportNumber1 > 0) {
                  if (!this.registar.passportNumber) {
                    this.SET_AVISO(this.$store.state.option['erro-passportNumber_register-' + this.lang])
                    return
                  }
                }
              }

              if (this.$store.state.option.phone_Number_register1 > 0) {
                if (!this.registar.phone_Number) {
                  this.SET_AVISO(this.$store.state.option['erro-phone_Number-' + this.lang])
                  return
                }
              }
              if (this.$store.state.option.mobile_Number_register1 > 0) {
                if (!this.registar.mobile_Number) {
                  this.SET_AVISO(this.$store.state.option['erro-mobile_Number-' + this.lang])
                  return
                }
              }
              dta.Driver = {
                Name: this.condutor,
                EMail: this.email,
                Date_of_Birth: this.formattedBirthDate,
                Address: this.registar.address,
                City: this.registar.city,
                Postal_code: this.registar.postal_Code,
                Phone: this.registar.phone_Number,
                Mobile: this.registar.mobile_Number,
                Country: this.registar.country,
                Tax_Number: this.registar.tax_number
              }

              if (this.$store.state.option.idNumber1 > 0 && parseInt(this.registar.document_Type) === 1) {
                if (this.registar.idNumber) {
                  dta.Driver.ID_Doc = {
                    Number: this.registar.idNumber
                  }
                }
              }
              if (this.registar.license_Number) {
                dta.Driver.DriverLicence = {
                  Number: this.registar.license_Number
                }
              }
              if (this.$store.state.option.passportNumber1 > 0 && parseInt(this.registar.document_Type) === 2) {
                if (this.registar.passportNumber) {
                  dta.Driver.PassportData = {
                    Number: this.registar.passportNumber
                  }
                }
              }
            }
            this.datasFim = {
              levantamento: a.getFullYear() + '-' + this.addZero(+a.getMonth() + 1) + '-' + this.addZero(a.getDate()) + ' ' + this.addZero(a1.getHours()) + ':' + this.addZero(a1.getMinutes()),
              devolucao: b.getFullYear() + '-' + this.addZero(+b.getMonth() + 1) + '-' + this.addZero(b.getDate()) + ' ' + this.addZero(b1.getHours()) + ':' + this.addZero(b1.getMinutes())
            }
            this.axios.post('/reservations', dta).then((res) => {
              window.scrollTo(0, 0)
              window.scrollTo(0, document.querySelector('#pesqReserva').getBoundingClientRect().top + 38)
              this.$localStorage.remove('reserva')
              this.reserva = res.data[0]
              this.passo = 2
              this.cartao = {
                CreditCardDueDate: '',
                CreditCardName: '',
                CreditCardNumber: ''
              }
              this.SET_LOAD1()
            }, (er) => {
              this.res = []
              this.SET_AVISO(er.response.data.error || er.response.data.message || er.response.data.status || er.response.data.Status)
            })
          } else {
            this.SET_AVISO(this.$store.state.option['erro-confirmacao3-' + this.lang])
          }
        } else {
          this.SET_AVISO(this.$store.state.option['erro-confirmacao2-' + this.lang])
        }
      } else {
        this.SET_AVISO(this.$store.state.option['erro-confirmacao1-' + this.lang])
      }
    },
    logar () {
      this.$modal.show('login-modal')
    },
    calc (index) {
      if (window.innerWidth > 800) {
        // sao 3 por linha
        return index === 3 || index === 4 || index === 5 || index === 9 || index === 10 || index === 11 || index === 15 || index === 16 || index === 17 || index === 21 || index === 22 || index === 23 || index === 27 || index === 28 || index === 29
      }
      return !(index % 2) || index === 0
    },
    submitDriver () {
      this.SET_LOAD1(true)
      this.axios.post('/drivers/login', this.form2).then((res) => {
        this.$modal.hide('login-modal')
        res.data.date_of_Birth = res.data.Date_of_Birth
        res.data.role = 'driver'
        this.SET_USER(res.data)
        if (this.aniversario !== res.data.date_of_Birth) {
          this.SET_TOAST({ msg: this.$store.state.option['erro-birth_date-updated-' + this.lang], type: 'warning' })
          this.form1.confirmacao1 = ''
          this.form1.confirmacao2 = ''
          this.form1.confirmacao3 = ''
          this.aniversario = res.data.date_of_Birth
          this.searchFN(1)
        }
        this.SET_LOAD1()
      }, (er) => {
        this.SET_AVISO(er.response.data.error || er.response.data.message || er.response.data.status || er.response.data.Status)
      })
    },
    registarFN () {
      if (!this.registar.driver_Name) {
        this.SET_AVISO(this.$store.state.option['erro-driver_Name-' + this.lang])
        return
      }
      if (this.$store.state.option.address_register > 0) {
        if (!this.registar.address) {
          this.SET_AVISO(this.$store.state.option['erro-address_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.postal_Code_register > 0) {
        if (!this.registar.postal_Code) {
          this.SET_AVISO(this.$store.state.option['erro-postal_Code_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.city_register > 0) {
        if (!this.registar.city) {
          this.SET_AVISO(this.$store.state.option['erro-city_register-' + this.lang])
          return
        }
      }
      if (!this.registar.country) {
        this.SET_AVISO(this.$store.state.option['erro-country_register-' + this.lang])
        return
      }
      if (this.$store.state.option.license_Number_register > 0) {
        if (!this.registar.license_Number) {
          this.SET_AVISO(this.$store.state.option['erro-license_Number_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.license_Country_register > 0) {
        if (!this.registar.license_Country) {
          this.SET_AVISO(this.$store.state.option['erro-license_Country_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.document_type_register > 0) {
        if (!this.registar.document_Type) {
          this.SET_AVISO(this.$store.state.option['erro-document_Type-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.document_number_register > 0) {
        if (!this.registar.document_Number) {
          this.SET_AVISO(this.$store.state.option['erro-document_Number-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.document_Place_register > 0) {
        if (!this.registar.document_Place) {
          this.SET_AVISO(this.$store.state.option['erro-document_Place-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.phone_Number_register > 0) {
        if (!this.registar.phone_Number) {
          this.SET_AVISO(this.$store.state.option['erro-phone_Number-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.mobile_Number_register > 0) {
        if (!this.registar.mobile_Number) {
          this.SET_AVISO(this.$store.state.option['erro-mobile_Number-' + this.lang])
          return
        }
      }
      if (!this.registar.email) {
        this.SET_AVISO(this.$store.state.option['erro-email1-' + this.lang])
        return
      }
      if (!this.registar.password) {
        this.SET_AVISO(this.$store.state.option['erro-pass1-' + this.lang])
        return
      }
      if (this.registar.password !== this.registar.password1) {
        this.SET_AVISO(this.$store.state.option['erro-rpass1-' + this.lang])
        return
      }
      this.SET_LOAD1(true)

      this.registar.date_of_Birth = this.aniversario
      // verify which date format is used in vuex:
      if (this.$store.state.option.date_format === 'DD-MM-YYYY') {
        this.registar.date_of_Birth = this.toggleISOandEUformat(this.aniversario)
      }
      this.axios.post('/drivers/register', this.registar).then((res) => {
        this.axios.post('/drivers/login', { email: this.registar.email, password: this.registar.password }).then((res) => {
          this.$modal.hide('registar-modal')
          res.data.date_of_Birth = res.data.Date_of_Birth
          res.data.role = 'driver'
          this.SET_USER(res.data)
          if (this.paypal) {
            this.axios.patch('/reservations/driver', { DriverID: this.$store.state.user.driverID || this.$store.state.user.DriverID, Reservation_Number: this.reserva.Reservation_Nr }).then((res) => {
              window.location = '/paypal/create-payment/' + this.reserva.Reservation_Nr
            }, (er) => {
              this.SET_AVISO(er.response.data[0].error || er.response.data[0].message || er.response.data[0].status || er.response.data[0].Status)
            })
          } else {
            this.cartaoFN()
          }
        }, (er) => {
          this.SET_AVISO(er.response.data.error || er.response.data.message || er.response.data.status || er.response.data.Status)
        })
      }, (er) => {
        if (er.response.data.error) {
          this.SET_AVISO(er.response.data.error)
          return
        }
        if (er.response.data.errors) {
          for (let a in er.response.data.errors) {
            this.SET_AVISO(er.response.data.errors[a][0])
            break
          }
        }
        // this.SET_AVISO(er.response.data.errors || er.response.data.message)
      })
    },
    cartaoFNRegisto () {
      if (!this.cartao.CreditCardNumber) {
        this.SET_AVISO(this.$store.state.option['erro-CreditCardNumber-' + this.lang])
        return
      } else if (this.cardCheck(this.cartao.CreditCardNumber)) {
        this.SET_AVISO(this.$store.state.option['erro-CreditCardNumber-' + this.lang])
        return
      }
      if (!this.cartao.CreditCardName) {
        this.SET_AVISO(this.$store.state.option['erro-CreditCardName-' + this.lang])
        return
      }
      if (!this.cartao.CreditCardDueDate) {
        this.SET_AVISO(this.$store.state.option['erro-CreditCardDueDate-' + this.lang])
        return
      }
      let a = this.cartao.CreditCardDueDate.split('/')
      if (!(a[0] < 13 && a[1] >= new Date().getFullYear() && a[1] < 2050)) {
        this.SET_AVISO(this.$store.state.option['erro-CreditCardDueDate-' + this.lang])
        return
      }
      if (this.$store.state.user) {
        this.cartaoFN()
      } else {
        this.$swal({
          title: this.$store.state.option['registarContCartaoCredito1-' + this.lang],
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: this.$store.state.option['registarContCartaoCredito-cancel-' + this.lang],
          confirmButtonText: this.$store.state.option['registarContCartaoCredito-ok-' + this.lang]
        }).then((result) => {
          if (result.value) {
            this.$modal.hide('cartao-modal')
            this.$modal.show('registar-modal')
            this.registar.driver_Name = this.condutor
            this.registar.email = this.email
            if (parseInt(this.registar.document_Type) === 1) {
              this.registar.document_Number = this.registar.idNumber
            }
            if (parseInt(this.registar.document_Type) === 2) {
              this.registar.document_Number = this.registar.passportNumber
            }
          } else {
            this.cartaoFN()
          }
        })
      }
    },
    cartaoFN () {
      this.gtag_report_conversion()

      this.SET_LOAD1(true)
      let dta = {
        PreAuthorization: {
          CreditCardDueDate: this.cartao.CreditCardDueDate.substring(0, 3) + this.cartao.CreditCardDueDate.substring(5, 7),
          CreditCardName: this.cartao.CreditCardName,
          CreditCardNumber: this.cartao.CreditCardNumber
        },
        Reservation_Number: this.reserva.Reservation_Nr
      }
      if (this.$store.state.user) {
        dta.DriverID = this.$store.state.user.driverID || this.$store.state.user.DriverID
      }
      this.axios.patch('/reservations', dta).then((res) => {
        if (res.data[0].Status === 'C') {
          this.$router.push('/confirmed?id=' + this.reserva.Reservation_Nr + '&token=' + res.data[0].token, () => {})
        } else {
          this.SET_AVISO(res.data[0].Status)
          this.$modal.hide('registar-modal')
          this.$modal.show('cartao-modal')
        }
      }, (er) => {
        this.$modal.show('cartao-modal')
        this.SET_AVISO(er.response.data[0].error || er.response.data[0].message || er.response.data[0].status || er.response.data[0].Status)
      })
    },
    guestFN () {
      if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email))) {
        this.SET_AVISO(this.$store.state.option['erro-email1-' + this.lang])
        return
      }
      if (!this.condutor) {
        this.SET_AVISO(this.$store.state.option['reserved-escolha-condutor-' + this.lang])
        return
      }
      /*
      if (!this.form.driver_Name) {
        this.SET_AVISO(this.$store.state.option['erro-driver_Name-' + this.lang])
        return
      }
      */
      if (this.$store.state.option.country1 > 0) {
        if (!this.registar.country) {
          this.SET_AVISO(this.$store.state.option['erro-country_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.address_register1 > 0) {
        if (!this.registar.address) {
          this.SET_AVISO(this.$store.state.option['erro-address_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.postal_Code_register1 > 0) {
        if (!this.registar.postal_Code) {
          this.SET_AVISO(this.$store.state.option['erro-postal_Code_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.city_register1 > 0) {
        if (!this.registar.city) {
          this.SET_AVISO(this.$store.state.option['erro-city_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.license_Number_register1 > 0) {
        if (!this.registar.license_Number) {
          this.SET_AVISO(this.$store.state.option['erro-license_Number_register-' + this.lang])
          return
        }
      }
      if ((!this.registar.idNumber && this.$store.state.option.idNumber1 > 0) || (!this.registar.passportNumber && this.$store.state.option.passportNumber1 > 0)) {
        if (this.$store.state.option.idNumber1 > 0 && parseInt(this.registar.document_Type) === 1) {
          this.registar.passportNumber = ''
          if (!this.registar.idNumber) {
            this.SET_AVISO(this.$store.state.option['erro-idNumber_register-' + this.lang])
            return
          }
        }
        if (this.$store.state.option.passportNumber1 > 0 && parseInt(this.registar.document_Type) === 2) {
          this.registar.idNumber = ''
          if (!this.registar.passportNumber) {
            this.SET_AVISO(this.$store.state.option['erro-passportNumber_register-' + this.lang])
            return
          }
        }
      }
      if (this.$store.state.option.taxNumber1 > 0) {
        if (!this.registar.tax_number) {
          this.SET_AVISO(this.$store.state.option['erro-taxNumber_register-' + this.lang])
          return
        }
      }

      if (this.$store.state.option.phone_Number_register1 > 0) {
        if (!this.registar.phone_Number) {
          this.SET_AVISO(this.$store.state.option['erro-phone_Number-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.mobile_Number_register1 > 0) {
        if (!this.registar.mobile_Number) {
          this.SET_AVISO(this.$store.state.option['erro-mobile_Number-' + this.lang])
          return
        }
      }

      this.logindriver = 2
      this.$modal.hide('guest-modal')
    },
    gtag_report_conversion (url) {
      if (localStorage.getItem('cookiesStatistics') && this.$store.state.option.googleTagPaymentEventId && window.gtag) {
        var callback = function () {
          if (typeof (url) !== 'undefined') window.location = url
        }

        window.gtag('event', 'conversion', {
          'send_to': this.$store.state.option.googleTagPaymentEventId,
          'transaction_id': '',
          'event_callback': callback
        })
      }

      return false
    },
    paypalFN () {
      this.gtag_report_conversion()

      if (this.logindriver === 2) {
        this.paypal = true
        this.$swal({
          title: this.$store.state.option['registarContCartaoCredito1-' + this.lang],
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: this.$store.state.option['registarContCartaoCredito-cancel-' + this.lang],
          confirmButtonText: this.$store.state.option['registarContCartaoCredito-ok-' + this.lang]
        }).then((result) => {
          if (result.value) {
            this.$modal.hide('cartao-modal')
            this.$modal.show('registar-modal')
            this.registar.driver_Name = this.condutor
            this.registar.email = this.email
            if (parseInt(this.registar.document_Type) === 1) {
              this.registar.document_Number = this.registar.idNumber
            }
            if (parseInt(this.registar.document_Type) === 2) {
              this.registar.document_Number = this.registar.passportNumber
            }
          } else {
            window.location = '/paypal/create-payment/' + this.reserva.Reservation_Nr
          }
        })
      } else {
        window.location = '/paypal/create-payment/' + this.reserva.Reservation_Nr
      }
    },
    triggerDataLayer () {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ 'event': 'searchButton', 'values': { 'carResult': this.$store.state.cars, 'driverBirthday': this.aniversario, 'driver': this.drivers } })
    },
    cardCheck (cardNumber) {
      // americanExpress
      if (!Number(this.$store.state.option.americanExpress)) {
        const firstTwoDig = cardNumber.split(' ').join('').slice(0, 2)
        const cardLength = cardNumber.split(' ').join('').length
        const americaLength = 15
        if ((cardLength === americaLength && Number(firstTwoDig) === 34) || (cardLength === americaLength && Number(firstTwoDig) === 37)) {
          return true
        }
      }
      // Diners Club
      if (!Number(this.$store.state.option.dinersClub)) {
        const firstTwoDig = cardNumber.split(' ').join('').slice(0, 2)
        const firstThreeDig = cardNumber.split(' ').join('').slice(0, 2)
        const cardLength = cardNumber.split(' ').join('').length
        const dinnerLength = 14
        if ((cardLength === dinnerLength && Number(firstTwoDig) === 36) || (cardLength === dinnerLength && Number(firstThreeDig) === 300) || (cardLength === dinnerLength && Number(firstThreeDig) === 301) || (cardLength === dinnerLength && Number(firstThreeDig) === 302) || (cardLength === dinnerLength && Number(firstThreeDig) === 303) || (cardLength === dinnerLength && Number(firstThreeDig) === 304) || (cardLength === dinnerLength && Number(firstThreeDig) === 305)) {
          return true
        }
      }
      return false
    },
    activateObservationModel (extraId) {
      this.observationExtraId = extraId
      this.$modal.show('extra-obs-modal')
    },

    setDatesFormat (dates, whichDate) {
      if (whichDate === 'checkout') {
        let checkoutDateFormatted = dates.levantamento
        if (this.$store.state.option.date_format === 'DD-MM-YYYY') {
          let splitCheckoutDate = dates.levantamento.split(' ')[0].split('-')
          checkoutDateFormatted = `${splitCheckoutDate[2]}-${splitCheckoutDate[1]}-${splitCheckoutDate[0]} ${dates.levantamento.split(' ')[1]}`
        }
        return checkoutDateFormatted
      } else {
        let checkinDateFormatted = dates.devolucao
        if (this.$store.state.option.date_format === 'DD-MM-YYYY') {
          let splitCheckinDate = dates.devolucao.split(' ')[0].split('-')
          checkinDateFormatted = `${splitCheckinDate[2]}-${splitCheckinDate[1]}-${splitCheckinDate[0]} ${dates.devolucao.split(' ')[1]}`
        }
        return checkinDateFormatted
      }
    }
  }
}
</script>
